import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Welcome back");
      const from = location.state?.from || (res.user.role === "admin" ? "/admin" : "/account");
      navigate(from);
    } else {
      setError(res.error);
    }
  };

  return (
    <div data-testid="login-page" className="max-w-md mx-auto px-6 py-24">
      <p className="overline">Sign in</p>
      <h1 className="mt-2 font-serif text-4xl text-[#1e392a] tracking-tight">Welcome back.</h1>
      <form onSubmit={submit} className="mt-10 space-y-5">
        <div>
          <Label className="text-xs uppercase tracking-widest text-[#8a8d86]">Email</Label>
          <Input
            data-testid="login-email-input"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="bg-white border-[#e6e2d8] mt-2 h-11"
          />
        </div>
        <div>
          <Label className="text-xs uppercase tracking-widest text-[#8a8d86]">Password</Label>
          <Input
            data-testid="login-password-input"
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="bg-white border-[#e6e2d8] mt-2 h-11"
          />
        </div>
        {error && (
          <p data-testid="login-error" className="text-sm text-[#c36a4f]">
            {error}
          </p>
        )}
        <Button
          type="submit"
          data-testid="login-submit-btn"
          disabled={loading}
          className="w-full h-12 rounded-full bg-[#1e392a] hover:bg-[#14251b] text-white"
        >
          {loading ? "Signing in…" : "Sign in"}
        </Button>
      </form>
      <p className="mt-6 text-sm text-[#8a8d86]">
        New to ARIALOK?{" "}
        <Link data-testid="login-to-register-link" to="/register" className="text-[#c36a4f] hover:underline">
          Create an account
        </Link>
      </p>
    </div>
  );
}
